// Parse human-readable message from ethers / wallet errors.
export const parseError = (err) => {
  if (!err) return 'Unknown error';
  if (typeof err === 'string') return err;

  // User rejected
  if (err.code === 4001 || err.code === 'ACTION_REJECTED') return 'Transaction rejected';

  // Common nested locations for revert reasons
  const reasons = [
    err?.reason,
    err?.error?.message,
    err?.data?.message,
    err?.error?.data?.message,
    err?.shortMessage,
    err?.message
  ].filter(Boolean);

  for (const r of reasons) {
    const cleaned = cleanReason(r);
    if (cleaned) return cleaned;
  }
  return 'Transaction failed';
};

const cleanReason = (raw) => {
  if (!raw) return null;
  let s = String(raw);
  // Strip prefixes
  s = s.replace(/^execution reverted:?\s*/i, '');
  s = s.replace(/^Error:\s*/i, '');
  s = s.replace(/^VM Exception while processing transaction:\s*revert\s*/i, '');
  s = s.replace(/^MetaMask Tx Signature:\s*/i, '');
  // Trim long technical garbage
  if (s.length > 240) s = s.slice(0, 240) + '...';
  // Drop empty
  s = s.trim();
  return s || null;
};
